import React from 'react'
import {useSelector} from 'react-redux'
import {useIsraeliVatEligibility} from 'hooks/useIsraeliVatEligibility'
import {getAllTaxesIncluded, getCurrencyCode} from 'modules/meta/selectors'
import {getShowTotalPrices} from 'modules/sapiSearch/selectors'

import {useDeviceLayout} from '@vio/atlas/src/context/deviceLayout'
import {BaseTaxationAndPriceMessage} from '@vio/shared/src/search/BaseTaxationAndPriceMessage'

interface Props {
  /** Whether to show the currency code or not */
  showCurrencyCode?: boolean
  /** The hotel id to find the offer entity which contains the number of rooms */
  hotelId: string
  /** Whether to show the price message or not */
  showPriceMessage?: boolean
  /** Whether the booking is split */
  isSplitBooking?: boolean
  /** The number of rooms for the offer, used to display the correct message */
  numberOfRooms?: number
  /** The number of nights for the offer, used to display the correct message */
  numberOfNights?: number
}

export const TaxationAndPriceMessage = ({
  showCurrencyCode = false,
  hotelId,
  showPriceMessage = true,
  isSplitBooking = false,
  numberOfRooms,
  numberOfNights
}: Props) => {
  const {isMobile} = useDeviceLayout()
  const includeTaxes = useSelector(getAllTaxesIncluded)
  const currencyCode = useSelector(getCurrencyCode)
  const showTotalPrices = useSelector(getShowTotalPrices)
  const {hasAdditionalCharges} = useIsraeliVatEligibility(hotelId)

  const taxationId = isMobile
    ? `HotelCardMobileTaxationAndPrice-${hotelId}`
    : `HotelCardDesktopTaxationAndPrice-${hotelId}`

  return (
    <BaseTaxationAndPriceMessage
      id={taxationId}
      includeTaxes={includeTaxes || showTotalPrices}
      currencyCode={showCurrencyCode ? currencyCode : undefined}
      showTotalPrices={showTotalPrices}
      showPriceMessage={showPriceMessage}
      withAdditionalCharges={hasAdditionalCharges}
      isSplitBooking={isSplitBooking}
      numberOfRooms={numberOfRooms}
      numberOfNights={numberOfNights}
    />
  )
}
